import Navbar from "./components/Navbar";
import HeroSection from "./components/HeroSection";
import DataIngestionSection from "./components/DataIngestionSection";
import HighlightDetectionSection from "./components/HighlightDetectionSection";
import AIEditingSection from "./components/AIEditingSection";
import ShortFormSection from "./components/ShortFormSection";
import DistributionSection from "./components/DistributionSection";
import DashboardSection from "./components/DashboardSection";
import ContentLibrarySection from "./components/ContentLibrarySection";
import PerformanceSection from "./components/PerformanceSection";
import CTASection from "./components/CTASection";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <div className="min-h-screen" style={{ backgroundColor: "#0A0E14", fontFamily: "'Inter', sans-serif" }}>
      <Navbar />
      <main>
        <HeroSection />
        <DataIngestionSection />
        <HighlightDetectionSection />
        <AIEditingSection />
        <ShortFormSection />
        <DistributionSection />
        <DashboardSection />
        <ContentLibrarySection />
        <PerformanceSection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
}
